export function LightUI() {
  return (
    <svg
      width="170"
      height="96"
      viewBox="0 0 170 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="170" height="96" rx="5" fill="#E1E1E1" />
      <rect x="50" y="7" width="113" height="82" rx="4.88462" fill="white" />
      <rect
        x="6.51367"
        y="6.51282"
        width="37.4487"
        height="83.0385"
        rx="4.88462"
        fill="white"
      />
      <circle cx="12.2118" cy="83.8526" r="2.44231" fill="#DDDDDD" />
      <rect
        x="17.9121"
        y="83.0385"
        width="14.6538"
        height="1.62821"
        rx="0.814103"
        fill="#DDDDDD"
      />
    </svg>
  );
}
